import moment from 'moment'

export function pad(value, size) {
    return ('000000000' + value).substr(-size);
}

export function formatDuration(val) {
    return moment.utc(val).format('mm:ss')
}

export function minutesToDuration(val) {
    const duration = moment.duration(val, 'minutes');

    const hours = pad(Math.round(duration.get('hours')), 2)
    const minutes = pad(Math.round(duration.get('minutes')), 2)
    const seconds = pad(Math.round(duration.get('seconds')), 2)

    return `${hours}:${minutes}:${seconds}`;
}

export function formatDate(val) {
    return moment(val).format('YYYY-MM-DD')
}

export function formatSize(a,f,b,c,d,e){
    const decimals = typeof f === 'undefined' ? 1 : f
    return (b=Math,c=b.log,d=1e3,e=c(a)/c(d)|0,a/b.pow(d,e)).toFixed(decimals)
    +' '+(e?'kMGTPEZY'[--e]+'B':'Bytes')
}

export function formatArtists(artists){
    if (!artists) return ''
    return [...artists].filter(a => a.isVisible)
        .sort((a, b) => {
            if (a.displayOrder == b.displayOrder) return 0;
            if (a.displayOrder > b.displayOrder) return 1;
            return -1;
        })
        .map(artist => artist.name)
        .join(' - ')
}

export function formatStyles(styles){
    if (!styles) return ''
    return [...styles].sort((a, b) => {
        if (a.displayOrder == b.displayOrder) return 0;
        if (a.displayOrder > b.displayOrder) return 1;
        return -1;
    })
    .map(style => style.name)
    .join(', ')
}
export function formatLabels(labels){
    if (!labels) return ''
    return labels
        .map(l => l.name)
        .join(', ')
}

export function formatTags(tags){
   return (tags || []).map(t => t.name).join(', ')
}

export function formatLanguages(languages){
    if (!languages) return ''
    return [...languages].sort((a, b) => {
        if (a.displayOrder == b.displayOrder) return 0;
        if (a.displayOrder > b.displayOrder) return 1;
        return -1;
    })
    .map(language => language.code)
    .join(', ')
}

